import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {
  iconPack: 'fontawesome',
  duration: 4000,
  position: 'top-right',
  theme: 'toasted-primary',
})

Vue.toasted.register(
  'defaultSuccess',
  payload => (!payload.msg ? '<h3>Operação realidada com sucesso</h3>!' : payload.msg),
  { icon: 'check-circle' },
)

Vue.toasted.register(
  'defaultError',
  payload => (!payload.msg ? 'Oops.. Erro inesperado.' : `<h3>${payload.msg}</h3>`),
  { icon: 'exclamation-circle' },
)
